import _ from 'lodash';

import urls from '../../urls';
import { featureRoute } from '../helpers';
import { SeasonStages } from '../../constants/AppConstants';
import SeasonSearchActions from '../../actions/SeasonSearchActions';

export default featureRoute('enableSeasonTickets', SeasonStages.RESULTS, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/seasonTicket/results/SeasonTicketResults').default);
        }, 'season-results');
    },

    onEnter (nextState, replace, callback) {
        const { params, location } = nextState;
        SeasonSearchActions.loadFromParams(params, location.query).then((search) => {
            if (!search.isValid()) {
                replace(urls.location(SeasonStages.SEARCH, null, location.query));
            }
           _.defer(callback);
        });
    }
});
